import React from "react";
import { connect } from "react-redux";
import QuoteStepBase from '../components/QuoteStepBase';
import { IQuoteStepComponentProps } from "../components/interfaces";
import QuoteStepLight from "./QuoteStepLightLayout";
import { IQuoteApiClient, IPaths } from "../classes/Domain";
import { IAppState } from "../state/interfaces";
import QuoteActions from "../state/appActions";
import { QUOTE_STEPS } from "../AppConstants";


interface IProps extends IQuoteStepComponentProps {
    quoteApiClient: IQuoteApiClient,
    PATHS: IPaths;
}

class QuoteThankYou extends QuoteStepBase<IProps, any> {
    constructor(props: IProps) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    render() {
        return (
            <QuoteStepLight id={this.props.id}>
                <div className="titleArea">
                    <h5>Thank you</h5>
                </div>
                <p className="info text-center">
                    Thank you for your interest. If you change your mind, you can start a new quote anytime.
                </p>
            </QuoteStepLight>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(QUOTE_STEPS.COVERAGES))
    };
};

export default connect(mapProps, mapDispatch)(QuoteThankYou);
